import {Component, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {escapeForRegExp} from '../../../utils/string.utils';

@Component({
    selector: 'app-highlight-term',
    standalone: true,
    template: `<span *ngFor="let part of parts; let i = index" [class.highlight-text]="i % 2">{{part}}</span>`,
    imports: [
        CommonModule,
    ],
})
export class HighlightTermComponent implements OnChanges {
    @Input() text: string | number;
    @Input() term: string;
    @Input() partialMatch: boolean = false;
    parts: string[];

    ngOnChanges() {
        const text = this.text == null ? '' : `${this.text}`;

        if (!this.term) {
            this.parts = [text];
            return;
        }

        if (this.partialMatch) {
            const words = this.term.trim().split(/\s+/).map(word => escapeForRegExp(word));
            const pattern = words.join('|');
            const regex = new RegExp(`(\\b(?:${pattern})\\b)`, 'gi');
            this.parts = text.split(regex);
        } else {
            this.parts = text.split(new RegExp(`(${escapeForRegExp(this.term)})`, 'gi'));
        }
    }
}
